import * as e from "react";
import { c as s } from "../cn-Edy-X8i3.js";
import "clsx";
import "tailwind-merge";
const M = e.forwardRef(
  function(t, c) {
    const {
      className: i,
      containerClassName: m,
      errorMsg: r,
      label: p,
      id: o,
      type: u,
      ...d
    } = t, [l, w] = e.useState(u), n = e.useMemo(
      () => l === "password",
      [l]
    );
    return /* @__PURE__ */ e.createElement("div", { className: s("flex flex-col", m) }, /* @__PURE__ */ e.createElement("label", { htmlFor: o, className: "mb-1 block font-bold" }, p), /* @__PURE__ */ e.createElement("div", { className: "relative" }, /* @__PURE__ */ e.createElement(
      "input",
      {
        ref: c,
        id: o,
        className: s(
          "block w-full rounded-sm border px-4 py-2 placeholder:text-secondary focus-visible:outline-none",
          i,
          {
            "border-red-600": r,
            "pr-12": t.type === "password"
          }
        ),
        type: l,
        ...d
      }
    ), t.type === "password" && /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: "absolute right-3 top-1/2 -translate-y-1/2 select-none outline-none",
        onClick: (a) => {
          a.stopPropagation(), a.preventDefault(), w(n ? "text" : "password");
        }
      },
      n ? /* @__PURE__ */ e.createElement(f, { className: "size-6" }) : /* @__PURE__ */ e.createElement(g, { className: "size-6" })
    )), r && /* @__PURE__ */ e.createElement("div", { className: "flex items-center gap-1 text-critical" }, /* @__PURE__ */ e.createElement(h, { className: "size-6 shrink-0" }), r));
  }
);
function f(C) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...C
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M21.9199 11.6C19.8999 6.91 16.0999 4 11.9999 4C7.89994 4 4.09994 6.91 2.07994 11.6C2.02488 11.7262 1.99646 11.8623 1.99646 12C1.99646 12.1377 2.02488 12.2738 2.07994 12.4C4.09994 17.09 7.89994 20 11.9999 20C16.0999 20 19.8999 17.09 21.9199 12.4C21.975 12.2738 22.0034 12.1377 22.0034 12C22.0034 11.8623 21.975 11.7262 21.9199 11.6ZM11.9999 18C8.81994 18 5.82994 15.71 4.09994 12C5.82994 8.29 8.81994 6 11.9999 6C15.1799 6 18.1699 8.29 19.8999 12C18.1699 15.71 15.1799 18 11.9999 18ZM11.9999 8C11.2088 8 10.4355 8.2346 9.77766 8.67412C9.11987 9.11365 8.60718 9.73836 8.30443 10.4693C8.00168 11.2002 7.92246 12.0044 8.0768 12.7804C8.23114 13.5563 8.61211 14.269 9.17152 14.8284C9.73093 15.3878 10.4437 15.7688 11.2196 15.9231C11.9955 16.0775 12.7998 15.9983 13.5307 15.6955C14.2616 15.3928 14.8863 14.8801 15.3258 14.2223C15.7653 13.5645 15.9999 12.7911 15.9999 12C15.9999 10.9391 15.5785 9.92172 14.8284 9.17157C14.0782 8.42143 13.0608 8 11.9999 8ZM11.9999 14C11.6044 14 11.2177 13.8827 10.8888 13.6629C10.5599 13.4432 10.3036 13.1308 10.1522 12.7654C10.0008 12.3999 9.9612 11.9978 10.0384 11.6098C10.1155 11.2219 10.306 10.8655 10.5857 10.5858C10.8654 10.3061 11.2218 10.1156 11.6098 10.0384C11.9977 9.96126 12.3999 10.0009 12.7653 10.1522C13.1308 10.3036 13.4431 10.56 13.6629 10.8889C13.8826 11.2178 13.9999 11.6044 13.9999 12C13.9999 12.5304 13.7892 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 11.9999 14Z",
        fill: "currentColor"
      }
    )
  );
}
function h(C) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...C
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12 7C11.7348 7 11.4804 7.10536 11.2929 7.29289C11.1054 7.48043 11 7.73478 11 8V12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12V8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7ZM12.92 15.62C12.8981 15.5563 12.8679 15.4957 12.83 15.44L12.71 15.29C12.5694 15.1512 12.3908 15.0572 12.1968 15.0199C12.0028 14.9825 11.8021 15.0034 11.62 15.08C11.4988 15.1306 11.3872 15.2017 11.29 15.29C11.1973 15.3834 11.124 15.4943 11.0742 15.6161C11.0245 15.7379 10.9992 15.8684 11 16C11.0016 16.1307 11.0288 16.2598 11.08 16.38C11.1249 16.5041 11.1966 16.6168 11.2899 16.7101C11.3832 16.8034 11.4959 16.8751 11.62 16.92C11.7397 16.9729 11.8691 17.0002 12 17.0002C12.1309 17.0002 12.2603 16.9729 12.38 16.92C12.5041 16.8751 12.6168 16.8034 12.7101 16.7101C12.8034 16.6168 12.8751 16.5041 12.92 16.38C12.9712 16.2598 12.9984 16.1307 13 16C13.0049 15.9334 13.0049 15.8666 13 15.8C12.9828 15.7362 12.9558 15.6755 12.92 15.62ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z",
        fill: "currentColor"
      }
    )
  );
}
function g(C) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...C
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M10.9399 6.07994C11.2907 6.02617 11.6451 5.99943 11.9999 5.99994C15.1799 5.99994 18.1699 8.28994 19.9099 11.9999C19.6438 12.5645 19.3433 13.1122 19.0099 13.6399C18.9041 13.8038 18.8485 13.9949 18.8499 14.1899C18.8522 14.4082 18.9257 14.6197 19.0594 14.7922C19.1931 14.9647 19.3795 15.0888 19.5903 15.1455C19.8011 15.2021 20.0246 15.1883 20.2267 15.106C20.4289 15.0238 20.5986 14.8776 20.7099 14.6899C21.1759 13.9579 21.5806 13.1886 21.9199 12.3899C21.9736 12.2652 22.0013 12.1308 22.0013 11.9949C22.0013 11.8591 21.9736 11.7247 21.9199 11.5999C19.8999 6.90994 16.0999 3.99994 11.9999 3.99994C11.5306 3.99758 11.062 4.03774 10.5999 4.11994C10.4686 4.14227 10.343 4.19024 10.2302 4.26112C10.1174 4.332 10.0197 4.4244 9.94263 4.53304C9.86555 4.64169 9.81063 4.76445 9.78101 4.89432C9.75138 5.02419 9.74762 5.15862 9.76994 5.28994C9.79227 5.42126 9.84024 5.5469 9.91112 5.65968C9.982 5.77247 10.0744 5.87018 10.183 5.94726C10.2917 6.02433 10.4144 6.07925 10.5443 6.10888C10.6742 6.13851 10.8086 6.14227 10.9399 6.11994V6.07994ZM3.70994 2.28994C3.6167 2.1967 3.50601 2.12274 3.38419 2.07228C3.26237 2.02182 3.1318 1.99585 2.99994 1.99585C2.86808 1.99585 2.73751 2.02182 2.61569 2.07228C2.49387 2.12274 2.38318 2.1967 2.28994 2.28994C2.10164 2.47824 1.99585 2.73364 1.99585 2.99994C1.99585 3.26624 2.10164 3.52164 2.28994 3.70994L5.38994 6.79994C3.97551 8.16147 2.8498 9.79393 2.07994 11.5999C2.02488 11.7261 1.99646 11.8623 1.99646 11.9999C1.99646 12.1376 2.02488 12.2738 2.07994 12.3999C4.09994 17.0899 7.89994 19.9999 11.9999 19.9999C13.797 19.9875 15.5517 19.4524 17.0499 18.4599L20.2899 21.7099C20.3829 21.8037 20.4935 21.8781 20.6154 21.9288C20.7372 21.9796 20.8679 22.0057 20.9999 22.0057C21.132 22.0057 21.2627 21.9796 21.3845 21.9288C21.5064 21.8781 21.617 21.8037 21.7099 21.7099C21.8037 21.617 21.8781 21.5064 21.9288 21.3845C21.9796 21.2627 22.0057 21.132 22.0057 20.9999C22.0057 20.8679 21.9796 20.7372 21.9288 20.6154C21.8781 20.4935 21.8037 20.3829 21.7099 20.2899L3.70994 2.28994ZM10.0699 11.4799L12.5199 13.9299C12.3509 13.9784 12.1758 14.002 11.9999 13.9999C11.4695 13.9999 10.9608 13.7892 10.5857 13.4142C10.2107 13.0391 9.99994 12.5304 9.99994 11.9999C9.99789 11.8241 10.0215 11.649 10.0699 11.4799ZM11.9999 17.9999C8.81994 17.9999 5.82994 15.7099 4.09994 11.9999C4.74603 10.5737 5.66301 9.28652 6.79994 8.20994L8.56994 9.99994C8.15419 10.7587 7.99568 11.6319 8.1182 12.4884C8.24072 13.3449 8.63766 14.1386 9.24947 14.7504C9.86128 15.3622 10.655 15.7592 11.5115 15.8817C12.368 16.0042 13.2411 15.8457 13.9999 15.4299L15.5899 16.9999C14.501 17.6408 13.2634 17.9856 11.9999 17.9999Z",
        fill: "currentColor"
      }
    )
  );
}
export {
  M as TextField
};
